import { Badge } from '@shopify/polaris';

export const CARRIER_NAMES: Record<string, string> = {
  colissimo: 'Colissimo',
  chronopost: 'Chronopost',
  dhl: 'DHL Express',
  ups: 'UPS',
  fedex: 'FedEx',
  mondial_relay: 'Mondial Relay',
  dpd: 'DPD',
  gls: 'GLS',
  la_poste: 'La Poste',
  unknown: 'Inconnu',
};

export const STATUS_CONFIG: Record<
  string,
  { label: string; tone: 'success' | 'warning' | 'critical' | 'info' | 'attention' | undefined }
> = {
  pending: { label: 'En attente', tone: undefined },
  picked_up: { label: 'Pris en charge', tone: 'info' },
  in_transit: { label: 'En transit', tone: 'info' },
  out_for_delivery: { label: 'En livraison', tone: 'attention' },
  delivered: { label: 'Livré', tone: 'success' },
  exception: { label: 'Exception', tone: 'critical' },
  returned: { label: 'Retourné', tone: 'warning' },
  cancelled: { label: 'Annulé', tone: undefined },
  unknown: { label: 'Inconnu', tone: undefined },
};

export function getCarrierName(code: string): string {
  return CARRIER_NAMES[code] || code;
}

export function getStatusBadge(status: string) {
  const config = STATUS_CONFIG[status] || { label: status, tone: undefined };
  return <Badge tone={config.tone}>{config.label}</Badge>;
}

export function formatDate(dateString: string): string {
  const date = new Date(dateString);
  return date.toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export function formatDateTime(dateString: string): string {
  const date = new Date(dateString);
  return date.toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatRelativeTime(dateString: string): string {
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMins / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffMins < 1) {
    return 'À l\'instant';
  } else if (diffMins < 60) {
    return `Il y a ${diffMins} min`;
  } else if (diffHours < 24) {
    return `Il y a ${diffHours}h`;
  } else if (diffDays < 7) {
    return `Il y a ${diffDays}j`;
  } else {
    return formatDate(dateString);
  }
}
